module.exports = __webpack_public_path__ + "static/media/iconfinder_Kick_Scooter_3362526.82721f16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfinder_Kick_Scooter_3362526.svg
// module id = 200
// module chunks = 0